import { useToggleState } from '@cian/react-utils';

import * as React from 'react';

import { REQUIRED_FIELDS } from '../../../constants';

import { AreaPart } from '../AreaPart/AreaPart';
import { AreaPartHeader } from '../AreaPartHeader/AreaPartHeader';

import { IAreaPartControlledProps } from './types';

export const AreaPartСontrolled: React.FC<IAreaPartControlledProps> = props => {
  const { title, onRemoveBlock, areaPart, canBeDeleted } = props;
  const { state: isExpanded, toggle: toggleIsExpanded } = useToggleState(true);

  const hasEmptyFields = !REQUIRED_FIELDS.every(field => areaPart[field] != null);

  const onExpand = React.useCallback(() => {
    if (hasEmptyFields) {
      return;
    }

    toggleIsExpanded();
  }, [hasEmptyFields, toggleIsExpanded]);

  return (
    <>
      <AreaPartHeader
        title={title}
        onDelete={onRemoveBlock}
        expanded={isExpanded}
        onExpand={onExpand}
        isTooltipOpened={hasEmptyFields}
        canDelete={canBeDeleted}
      />
      {isExpanded && <AreaPart {...props} />}
    </>
  );
};
